import * as addonSelector from 'state/addonForm/addonForm.selector';
export interface OwnProps {
  tabId: string;
}

export interface StateProps {
  validationErrors: QuoteFormError[];

  hiddenFields: string[];
}

import { connect } from 'react-redux';
import type { QuoteFormError } from 'state/addonForm/addonForm.selector';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  return {
    validationErrors: addonSelector.getValidationErrors(state, tabId)!,
    hiddenFields: [],
  };
};

export const connectValidationErrors = connect(mapStateToProps);
